export const prerender = true;
// Must stay 'always': the CloudFront url_rewrite function (cloud/terraform/main.tf)
// serves extensionless paths from `<path>/index.html`. Canonical URLs are
// slash-less regardless (see +layout.svelte).
export const trailingSlash = 'always';
